var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3143 11.3608C29.4673 11.507 29.522 11.741 29.564 11.9548C29.9458 13.8943 30.3275 15.8338 30.7085 17.7733C31.4818 21.7025 32.762 27.7775 28.5373 30.2593C27.5623 30.8323 26.3585 31.052 25.2718 30.7393C23.5753 30.2518 22.4585 28.5988 21.923 26.9173C21.1393 24.4558 21.3005 21.7933 21.7123 19.2433C22.124 16.6933 22.7765 14.1755 22.9588 11.5993C22.9655 11.4988 22.9768 11.3885 23.0488 11.3188C23.1178 11.252 23.2228 11.243 23.3195 11.2378C25.1308 11.1395 26.9465 11.126 28.7593 11.1973C28.9265 11.204 29.1028 11.2138 29.2423 11.3053C29.2693 11.321 29.2925 11.3398 29.3143 11.3608Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3535 11.597C42.5315 11.6405 44.7088 11.6848 46.8868 11.7283C47.1148 11.7328 47.3608 11.7433 47.5423 11.8813C47.7785 12.0605 47.828 12.3883 47.8753 12.6808C48.509 16.571 51.908 19.562 52.6048 23.4418C52.7113 24.0365 52.7075 24.752 52.2283 25.1195C51.9118 25.3625 51.4805 25.3753 51.0808 25.3768C48.449 25.3895 45.8173 25.3948 43.1855 25.3933C46.175 25.4053 49.1638 25.4173 52.1533 25.43C51.4738 27.3845 50.1515 29.0015 48.2443 29.8783C47.7073 30.125 47.1163 30.3088 46.5305 30.2285C45.6778 30.1115 44.999 29.4643 44.465 28.7893C42.611 26.447 41.7733 23.456 41.345 20.4995C40.9168 17.543 40.8523 14.5385 40.3273 11.5978C40.3363 11.5963 40.3453 11.5963 40.3535 11.597Z",
    fill: "#FA532E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0854 52.5485C38.0854 52.5485 37.9632 54.152 37.3362 44.678C36.7085 35.2033 28.6002 31.5155 26.0839 44.3908C24.3117 53.4605 27.3012 52.4038 27.3012 52.4038L38.0854 52.5485Z",
    fill: "#FA532E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6815 27.1617V27.2037C42.6748 27.1895 42.6673 27.176 42.6605 27.1617H42.6815Z",
    fill: "#393B46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3302 45.0455C34.5305 45.0215 34.451 45.3268 34.3302 45.3268C34.2102 45.3275 34.1945 45.062 34.3302 45.0455Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9413 11C25.8245 11.2595 36.7078 11.5183 47.591 11.7778C48.6718 15.7985 51.7363 19.079 52.7225 23.1245C53.0915 24.6395 53.1545 26.21 53.207 27.7685C53.39 33.2262 53.459 38.6878 53.4155 44.1485C53.405 45.4588 53.3878 46.7697 53.3645 48.08C53.3518 48.7955 53.7193 51.7198 53.2393 52.2028C52.7248 52.7195 50.3945 52.34 49.6558 52.34C48.2285 52.34 46.8005 52.34 45.3733 52.34C34.3933 52.34 23.4125 52.34 12.4325 52.34C12.368 52.34 11.444 52.3527 11.4433 52.34C10.8808 44.6622 10.49 36.9717 10.271 29.2767C10.2305 27.8465 10.2005 26.3818 10.6558 25.025C11.1133 23.6623 12.0253 22.5095 12.764 21.2765C14.5963 18.218 15.3755 14.5415 14.9413 11Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.877 11.2272C22.877 11.2272 24.68 37.4037 10.6858 30.1835",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1152 11.3683C30.875 16.8613 31.5957 22.4765 31.8185 25.3378C24.446 37.9115 21.485 25.4068 21.485 25.4068",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8193 25.3378C31.8193 25.3378 34.3085 37.8388 42.8188 25.6003C46.49 33.6823 52.451 25.3033 52.451 25.3033H11.3383",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.285 11.6293L41.354 12.2885L42.6193 23.7808L42.8188 25.5988",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6355 52.3362C25.6355 52.3362 24.293 37.1135 29.8775 35.9855C35.4545 34.8575 37.3648 40.88 37.5103 46.457C37.5485 48.1137 37.5718 50.216 37.5718 52.3407",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon-company.971c5f9c7f1b8a0d2658e9d03e922a56.svg";
export { ForwardRef as ReactComponent };